import { UpdateKeyValueRequest } from "../base/updateKeyValueRequest.model";

/**
 * tieneComision tiene que viajar siempre: la API arma la entidad entera desde el
 * request, y si no viene, editar la descripción lo pisa en false.
 */
export class UpdateTipoBonificacionRequest extends UpdateKeyValueRequest {
  public tieneComision: boolean = false
}
